<template>
  <div class="chart-card">
    <div class="chart-header">
      <div class="chart-title-block">
        <span class="chart-kicker">DISTRIBUCIÓN</span>
        <h3 class="chart-title">Por Tienda</h3>
      </div>
    </div>

    <div v-if="loading" class="chart-loading">Cargando…</div>
    <div v-else-if="distribucion.length === 0" class="chart-empty">Sin datos</div>
    <div v-else class="dist-list">
      <div v-for="t in distribucion" :key="t.tienda" class="dist-row">
        <div class="dist-info">
          <span class="dist-tienda">{{ formatStoreName(t.tienda) }}</span>
          <span class="dist-total">{{ t.total_comparados.toLocaleString() }}</span>
        </div>
        <div class="dist-bar">
          <div
            class="seg seg-win"
            :style="{ width: pct(t.ganamos, t.total_comparados) + '%' }"
            :title="`Ganamos: ${t.ganamos}`"
          >
            <span v-if="t.ganamos > 0">{{ t.ganamos }}</span>
          </div>
          <div
            class="seg seg-tie"
            :style="{ width: pct(t.empate, t.total_comparados) + '%' }"
            :title="`Empate: ${t.empate}`"
          >
            <span v-if="t.empate > 0">{{ t.empate }}</span>
          </div>
          <div
            class="seg seg-lose"
            :style="{ width: pct(t.perdemos, t.total_comparados) + '%' }"
            :title="`Perdemos: ${t.perdemos}`"
          >
            <span v-if="t.perdemos > 0">{{ t.perdemos }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="chart-legend">
      <div class="leg-item"><span class="leg-box leg-win"></span>Ganamos</div>
      <div class="leg-item"><span class="leg-box leg-tie"></span>Empate</div>
      <div class="leg-item"><span class="leg-box leg-lose"></span>Perdemos</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, defineProps } from 'vue';
import axios from 'axios';

const props = defineProps({
  vista: { type: String, default: 'web' }
});

const API = 'https://dash-visaovip.kompara.tech/api';
const getH = () => ({ headers: { Authorization: 'Bearer ' + localStorage.getItem('token_precios') } });

const distribucion = ref([]);
const loading = ref(true);

const pct = (val, total) => total > 0 ? (val / total * 100) : 0;

const formatStoreName = (s) => s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

const load = async () => {
  loading.value = true;
  try {
    const res = await axios.get(`${API}/stats/distribucion-por-tienda`, {
      ...getH(), params: { vista: props.vista }
    });
    distribucion.value = res.data.distribucion || [];
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

watch(() => props.vista, load);
onMounted(load);
</script>

<style scoped>
.chart-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.chart-header {
  padding: 10px 14px;
  background: var(--color-surface-3);
  border-bottom: 1px solid var(--color-accent-border);
}
.chart-kicker {
  display: block;
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: var(--color-accent);
  text-transform: uppercase;
}
.chart-title {
  margin: 2px 0 0;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}
.chart-loading, .chart-empty {
  padding: 40px 20px;
  text-align: center;
  color: var(--color-text-muted);
  font-family: var(--font-mono);
  font-size: 11px;
}

.dist-list {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.dist-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dist-info {
  display: flex;
  justify-content: space-between;
  font-family: var(--font-mono);
  font-size: 10.5px;
}
.dist-tienda {
  color: var(--color-text);
  font-weight: 600;
}
.dist-total {
  color: var(--color-text-faint);
  font-variant-numeric: tabular-nums;
}
.dist-bar {
  display: flex;
  height: 18px;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 2px;
  overflow: hidden;
}
.seg {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  color: white;
  transition: all 0.3s;
  min-width: 0;
  overflow: hidden;
}
.seg-win { background: var(--color-success); }
.seg-tie { background: var(--color-text-faint); }
.seg-lose { background: var(--color-danger); }

.chart-legend {
  padding: 8px 14px;
  background: var(--color-surface-2);
  border-top: 1px solid var(--color-border);
  display: flex;
  gap: 14px;
  font-family: var(--font-mono);
  font-size: 9.5px;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.leg-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
.leg-box {
  width: 10px;
  height: 8px;
  border-radius: 1px;
}
.leg-win { background: var(--color-success); }
.leg-tie { background: var(--color-text-faint); }
.leg-lose { background: var(--color-danger); }
</style>